<template>
    <RegisterCard transition="scale-transition" origin="center center" />
</template>

<script>
// Vuex
// import { mapGetters, mapState } from 'vuex';

// Api
// import MajorApi from '@/api/MajorApi';

// Components
import RegisterCard from "@/components/RegisterCard";

export default {
    name: "Register",
    components: {
        RegisterCard
    }
};
</script>

<style scoped></style>
